// extracted by mini-css-extract-plugin
export default {"multilineText":"style_multilineText__MSJll"};